import { Controller } from 'react-hook-form'
import NumberFormatterInput from './NumberFormatter'

export default ({
  name,
  control,
  label,
  defaultValue = '',
  disabled = false,
  validator = {}
}) => {

  return <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    render={({ field }) => (
      <>
        <label className={`input ${validator.hasError ? 'validator' : ''} currency-input`}
          {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
        >
          <span className="label">{label}</span>
          <NumberFormatterInput {...field} disabled={disabled} /> 
          <span className="label">€</span>
        </label>
        {validator.getErrorMessage && (
          <div className="validator-hint hidden pt-2 empty:py-[0.6rem]">
            {validator.getErrorMessage(name)}
          </div>
        )}
      </>
    )}
  />
}